// extracted by mini-css-extract-plugin
module.exports = {"header":"ExpenseTable_header__Se96U","table":"ExpenseTable_table__1fHkn"};